import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import { ConsultaInventarioAcopio } from "./components/ConsultaInventarioAcopio";
import "./styles/InventarioOtrosAcopios.css";

class InventarioOtrosAcopios extends Component {
    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="inventario_activo"
                    titulo="INVENTARIO DE OTROS ACOPIOS"
                    subtitulo=""
                    noBorder
                >
                    <ConsultaInventarioAcopio storageKey="inventario_otros_acopios_acopio" />
                </Card>
            </div>
        );
    }
}

export default InventarioOtrosAcopios;
